import React, { useEffect, useState } from "react";
import LayoutComponent from "./Layout.component";
import { useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { getMyInfo, sendEmailForAgencyVeification, verifyAgencyEmail } from "api/common/Auth.api";
import EmailVerificationPopup from "../popup/EmailVerificationPopup";
import * as AgencyApi from "api/agency/Agency.api";
import { setIsLogin, setInfo as setUserInfo } from "reducers/User";

const STANDALONE_MAIN_PATH = ["/casting/message/", "/my", "/student"];
const NO_MENU_PATH = ["/hub/notice/"];

const LayoutContainer = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const { info: userInfo } = useSelector((state: any) => state.user);
  const [showEmailVerificationPopup, setShowEmailVerificationPopup] = useState<boolean>(false);

  const needStandaloneMain = STANDALONE_MAIN_PATH.some(path => location.pathname.includes(path));
  const needNoMenu = NO_MENU_PATH.some(path => location.pathname.includes(path));

  useEffect(() => {
    console.log("Layout.container::userInfo", userInfo);

    // 이메일 인증이 필요한 경우 팝업 표시
    if (userInfo && userInfo.hasVerifiedEmail === false) {
      setShowEmailVerificationPopup(true);
    }
  }, [userInfo]);

  // 이메일 인증 확인 함수
  const handleEmailVerification = async (verificationCode?: string) => {
    try {
      // 인증번호가 제공된 경우 - verifyAgencyEmail API 호출
      console.log("인증번호 검증:", verificationCode);
      if (!verificationCode) {
        alert("인증번호를 입력해주세요.");
        return;
      }

      const result = await verifyAgencyEmail({
        email: userInfo.username,
        verificationCode: verificationCode
      });

      if (result && result.status === 200) {
        // 인증 성공 - 사용자 정보 재조회
        const myInfoResult = await getMyInfo();

        if (myInfoResult?.info) {
          const updatedUserInfo = myInfoResult.info;
          const result = await AgencyApi.getInfo(myInfoResult.info.userAgencyId);
          if (result) {
            myInfoResult.info.logoImageInfo = result.info.logoImageInfo ? result.info.logoImageInfo : null;
            myInfoResult.info.agencyName = result.info.agencyName;
          } else {
            myInfoResult.info.logoImageInfo = null;
          }

          const myInfo = myInfoResult.info;
          console.log("myInfo", { myInfo });
          dispatch(setUserInfo(myInfo));
          setShowEmailVerificationPopup(false);
        } else {
          window.location.reload();
        }
      }
    } catch (error) {
      console.error("이메일 인증 확인 실패:", error);
      alert("인증 확인 중 오류가 발생했습니다. 다시 시도해주세요.");
    }
  };

  // 이메일 인증 메일 재발송 함수
  const handleResendVerificationEmail = async () => {
    try {
      const result = await sendEmailForAgencyVeification({ email: userInfo.username });
      if (result && result.status === 200) {
        alert("메일 발송에 성공했습니다. 메일함을 확인해주세요~");
      }
    } catch (error) {
      console.error("인증 메일 재발송 실패:", error);
      alert("메일 발송에 실패했습니다. 잠시후 다시 시도해주세요.");
    }
  };

  return (
    <>
      <LayoutComponent needStandaloneMain={needStandaloneMain} needNoMenu={needNoMenu} />

      {/* 이메일 인증 팝업 */}
      {showEmailVerificationPopup && (
        <EmailVerificationPopup
          onClose={() => { }} // 팝업을 닫을 수 없음
          onVerify={handleEmailVerification}
          onResendEmail={handleResendVerificationEmail}
        />
      )}
    </>
  );
};

export default LayoutContainer;